/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

export function ProgramEditDialogHeader({ id }) {
    const [title, setTitle] = useState("");
    // Channel Redux state
    const { programForEdit, actionsLoading } = useSelector(
        (state) => ({
            programForEdit: state.programs.programForEdit,
            actionsLoading: state.channels.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id ? "" : "New Program";
        if (programForEdit && id) {
            _title = "Edit Program";
        }

        setTitle(_title);
        // eslint-disable-next-line
    }, [programForEdit, actionsLoading]);

    return (
        <>
            {actionsLoading && <ModalProgressBar variant="query" />}
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
            </Modal.Header>
        </>
    );
}
